import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {useSelector} from 'react-redux';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {userSelector} from 'entities/user';
import {ADMIN_PAYMENT_FILTER_KEYS, paymentAPI, PaymentsFiltersForm} from 'entities/payment';
import {IFiltersFormComponentProps} from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';
import {getPollingInterval} from 'shared/api/pollingHelper';
import AddPaymentButton from 'features/admin/ui/AddPaymentButton/AddPaymentButton';
import useListParams from 'shared/lib/hooks/useListParams';

import AdminListScreen from '../AdminList/AdminListScreen/AdminListScreen';
import PaymentRow from './PaymentRow';

const AdminPaymentsFiltersForm: React.FC<IFiltersFormComponentProps> = ({onClose}) => (
    <PaymentsFiltersForm onClose={onClose} admin/>
);

const Payments: React.FC = () => {
    const user = useSelector(userSelector);
    const params = useListParams({filterKeys: ADMIN_PAYMENT_FILTER_KEYS});
    const query = paymentAPI.useGetPaymentsQuery(
        {...params.args, all: true},
        {pollingInterval: getPollingInterval()},
    );

    return (
        <AdminListScreen
            title={t`Платежи пользователей`}
            heading={i18n._(Pages.PAYMENTS_USERS)}
            createButton={<AddPaymentButton/>}
            hideCreateButtonOnMobile
            columns={[
                {label: 'ID', sort: 'id'},
                {label: '№', sort: 'number'},
                {label: 'Пользователь', sort: 'user.email'},
                {label: 'Дата создания', sort: 'created_at'},
                {label: 'Сумма', sort: 'sum'},
                {label: 'Промокод'},
                {label: 'Тариф', sort: 'tariff.name'},
                {label: 'Период'},
                {label: 'Статус', sort: 'status'},
                {label: 'Авто', sort: 'auto'},
                {label: 'Дата оплаты', sort: 'payed_at'},
            ]}
            params={params}
            query={query}
            rowFactory={item => <PaymentRow key={item.id} item={item} tzString={user?.timezone}/>}
            FiltersForm={AdminPaymentsFiltersForm}
        />
    );
};

export default Payments;
